module.exports = __webpack_public_path__ + "img/bracket-13.ad1b9e52.svg";